import React from 'react';
import { Box, BoxExtendedProps, HintPlacement, ShimmerBox, Text } from '@common-fe/common-fe';
import _ from 'lodash';

import HintTitle from '../../HintTitle';
interface Props extends BoxExtendedProps {
  title: string;
  children: React.ReactNode;
  hint?: string;
  hintNode?: React.ReactNode;
  isLoading?: boolean;
  subfieldTitle?: string;
  preferAlign?: HintPlacement;
}
const StatisticsItem: React.FC<Props> = ({
  isLoading,
  title,
  children,
  hint,
  hintNode,
  subfieldTitle,
  preferAlign,
  ...rest
}) => {
  if (isLoading) {
    const getRandWidth = () => `${_.random(25, 80)}%`;
    return (
      <Box direction="column" fill data-testid={`statistics-item_${title}_loading`} {...rest}>
        <ShimmerBox
          height="12px"
          round="checkboxRound"
          margin={{ bottom: 'spacing4' }}
          width={getRandWidth()}
        />
        <ShimmerBox
          height="16px"
          round="checkboxRound"
          margin={{ bottom: 'spacing8' }}
          width={getRandWidth()}
        />
        <ShimmerBox height="12px" round="checkboxRound" width={getRandWidth()} />
      </Box>
    );
  }
  return (
    <Box direction="column" align="start" fill data-testid={`statistics-item_${title}`} {...rest}>
      <Text
        size="medium"
        weight={400}
        margin={{ bottom: 'spacing4' }}
        data-testid={`statistics-item_${title}_title`}
      >
        {title}
      </Text>
      <Box direction="row">
        <Text size="xxlarge" weight={700} data-testid={`statistics-item_${title}_value`}>
          {children}
        </Text>
      </Box>
      <Box>
        <HintTitle
          preferAlign={preferAlign}
          size="medium"
          weight={400}
          hint={
            hintNode || (
              <Text textAlign="center" size="small">
                {hint}
              </Text>
            )
          }
        >
          {subfieldTitle}
        </HintTitle>
      </Box>
    </Box>
  );
};

export default StatisticsItem;
